import { Box } from '@mui/material'
import { useLayoutEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Loader from '../../../components/loader'
import { useContextState } from '../../../hooks/theme'
import { colors } from '../../../utils/theme/colors'
import { TypeGlobalEnum } from '../../../utils/enums/globalContextEnum'

const LogOut = () => {
  const navigate = useNavigate()
  const { handleTheme, dispatch } = useContextState()
  useLayoutEffect(() => {
    const logout = () => {
      localStorage.clear() 
      dispatch({payload: {}, type: TypeGlobalEnum.RESTART})
      handleTheme({ color: colors('light') })
      setTimeout(() => {navigate('/auth')}, 1000)
    }
    logout()
  }, [navigate])
  return (
    <Box sx={{ height: '100vh' }}>
      <Loader />
    </Box>
  )
}

export default LogOut
